<template>
    <div>
    <!-- Preloader -->
    <!-- <div class="preloader d-flex align-items-center justify-content-center" v-if="loadingPage">
        <div class="cssload-container">
            <div class="cssload-loading"><i></i><i></i><i></i><i></i></div>
        </div>
    </div> -->
        <!-- ##### Breadcumb Area Start ##### -->
        <section class="breadcumb-area bg-img d-flex align-items-center justify-content-center" :style="`background-image: url(${offerList.MainImage})`">
            <!-- <div class="bradcumbContent">
                <h2>Rooms</h2>
            </div> -->
        </section>
        <!-- ##### Breadcumb Area End ##### -->
        <!-- ##### Rooms Area Start ##### -->
        <section class="rooms-area mt-5">
            <div class="container-fluid ">

                <div class="row">

                    <!-- Single Rooms Area -->
                    <div 
                    class="col-12 col-md-6 col-lg-4"  
                    data-aos="fade-up"
                    data-aos-offset="200"
                    data-aos-delay="10"
                    data-aos-duration="1000"
                    data-aos-once="true"
                    data-aos-anchor-placement="top-bottom"
                    v-for="(item, index) in offerList.tiles" :key="index">
                        <div class="single-rooms-area wow fadeInUp" data-wow-delay="100ms">
                            <!-- Thumbnail -->
                            <div class="bg-thumbnail bg-img" :style="{'background-image': 'url(https://www.malahini.mv:9443/web/api/picture/' + item.TileImageId + ')', 'background-position': 'center'}"></div>
                            <!-- Rooms Text -->
                            <div class="rooms-text" v-if="item.TileImageTitle">
                                <!-- <div class="line"></div> -->
                                <h4>{{item.TileImageTitle}}</h4>
                                <p>{{item.TileImageText}}</p>
                            </div>
                            <!-- Book Room -->
                            <span v-if=" item.TileType !== 'fill'">
                            <a v-if="item.TileType !== 'detail'" @click="openPdfModal(item.TileDetails)" class="book-room-btn btn palatin-btn white-text">Details</a>
                            <a v-else :href="`#/page/${offerList.PageName}/tile${index}`" class="book-room-btn btn palatin-btn">Details</a>
                            <!-- <a v-else :href="`#/page/${offerList.PageName}/tile${index}`" class="book-room-btn btn palatin-btn">Details</a> -->
                            </span>
                        </div>
                    </div>


                </div>
            </div>
        </section>
        <!-- ##### Rooms Area End ##### -->
        <!-- PDF Modal -->
        <div class="modal fade" id="pdfModal" tabindex="-1" role="dialog" aria-labelledby="pdfModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content" style="background-color: transparent;">
                <div class="modal-header" style="border-bottom: none;">
                    <button type="button" class="close white-text" data-dismiss="modal" aria-label="Close" style="font-size: 2.5rem;" >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="padding: 0;">
                    <!-- <object :data="pdfFile" type="application/pdf"  style="width: 100%; height: 80vh;">
                        alt : <a :href="pdfFile">File</a>
                    </object> -->
                    <!-- <embed :src="`${pdfFile}#zoom=100`" width="575" height="500"> -->
                    <iframe :src="`${pdfFile}`" style="width: 100%; height: 80vh;" border="0"></iframe>

                </div>
            </div>
            </div>
        </div>
        <!-- End of PDF Modal -->
    </div>
</template>

<script>
import {_} from 'vue-underscore';
import $ from 'jquery'
import 'bootstrap';
export default {
    name: "tiles",
    data: ()=>({
        offerList: [],
        page: null,
        loadingPage: false,
        pdfFile: ''
    }),
    watch: {
    //     '$route': (to, from) => {
    //         window.location.reload()
    //    }
    },
    metaInfo () { return {
            title: 'Malahini Kuda Bandos - ' + this.$route.params.mainType,
            meta: [
                { charset: 'utf-8' },
                { name: "description", content: "Malahini Kuda Bandos" +  + this.$route.params.mainType},
                { name: "keywords", content: "Malahini,Kuda Bandos," + this.$route.params.mainType }
            ]
        }        
    },
    mounted() {
        this.page = this.$route.params.mainType

        this.$http.get('https://www.malahini.mv:9443/web/api/page/' + this.page).then((response)=>{
            this.offerList = response.data
            this.offerList.tiles = _.sortBy(this.offerList.tiles, 'TileOrder')
            // console.log(this.offerList)
            this.loadingPage = false
        })
        
        // $.ajax({
        //     url: specialOffersUrl,
        //     type: 'GET',
        //     success: function(res) {
        //         console.log(res);
        //         alert(res);
        //     }
        // });
    },
    methods: {
        openPdfModal( link) {
            this.pdfFile = link
            $('#pdfModal').modal()
        }
    }
}
</script>